import React from 'react';
import { Core_Bump_Recommendation_ListingQuery } from '@reverbdotcom/commons/src/gql/graphql';
import { BumpModalBodyValuePropIteration } from './BumpModalBodyValuePropIteration';
import { BumpModalBodyTopPickIteration } from './BumpModalBodyTopPickIteration';
import { RCLoadingBars } from '@reverbdotcom/cadence/components';

export interface BumpRecommendationBodyProps {
  bid: number;
  selectedBid: number;
  handleBidChange: (bid: number) => void;
  successMessage: string;
  failMessage: string;
  onSubmit: () => void;
  hideSubmit?: boolean;
  showCustomWarning: boolean;
  setShowCustomWarning: React.Dispatch<React.SetStateAction<boolean>>;
  listing?: Core_Bump_Recommendation_ListingQuery['listing'];
  bumpRecommendationAmount: number | null;
  listingLoading?: boolean;
  showTopPickVariant?: boolean;
}

export function BumpRecommendationBody(props: BumpRecommendationBodyProps) {
  if (props.listingLoading || !props.listing || props.bumpRecommendationAmount === null) {
    return <div className="d-flex fx-justify-center padding-4"><RCLoadingBars /></div>;
  }

  const BodyComponent = props.showTopPickVariant
    ? BumpModalBodyTopPickIteration
    : BumpModalBodyValuePropIteration;

  return (
    <BodyComponent
      recommendationAmount={props.bumpRecommendationAmount}
      listing={props.listing}
      bid={props.bid}
      selectedBid={props.selectedBid}
      handleBidChange={props.handleBidChange}
      successMessage={props.hideSubmit ? '' : props.successMessage}
      failMessage={props.failMessage}
      hideSubmit={props.hideSubmit}
      onSubmit={props.onSubmit}
      showCustomWarning={props.showCustomWarning}
      setShowCustomWarning={props.setShowCustomWarning}
      minimumBumpBid={props.bid > 0 ? 0 : undefined}
    />
  );
}

export default BumpRecommendationBody;
